<template>
  <v-app id="login">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="0"
            sm="2"
            md="4"
          ></v-col>
          <v-col
            cols="12"
            sm="8"
            md="4"
            align="center"
            justify="center"
            style="margin-top: -80px;"
          >
            <v-img
              class="fill-height logo"
              width="139px"
              height="35px"
              src="@/assets/logo.png"
            />
          </v-col>
          <v-col
            cols="0"
            sm="2"
            md="4"
          ></v-col>
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="black"
                dark
                flat
              >
                <v-toolbar-title>登入</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form
                  v-model="isFormValid"
                  :lazy-validation="isFormLazyValidation"
                >
                  <v-text-field
                    v-model.trim="form.username"
                    label="帳號"
                    name="username"
                    prepend-icon="person"
                    type="text"
                    :rules="formRules.username"
                  />

                  <v-text-field
                    v-model="form.password"
                    label="密碼"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    :rules="formRules.password"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  :disabled="!isFormValid"
                  color="black"
                  @click="submit"
                >登入</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog
      scrollable
      v-model="isLoading"
      fullscreen
    >
      <v-container
        fluid
        fill-height
        style="background-color: rgba(0, 0, 0, 0.5);"
      >
        <v-layout
          justify-center
          align-center
        >
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    isLoading: false,
    isFormValid: false,
    isFormLazyValidation: false,
    formRules: {
      username: [v => !!v || "請輸入帳號"],
      password: [v => !!v || "請輸入密碼"]
    },
    form: {
      username: "",
      password: ""
    }
  }),
  methods: {
    submit() {
      const uploadAPNSToken = () => {
        let payload = {
          DeviceToken: this.$store.state.deviceInfo.token,
          DeviceType: "iOS"
        };
        return this.$services.deviceInfo
          .subscribe(this, payload)
          .catch(window.console.error);
      };

      const uploadSubscription = () => {
        let payload = {
          DeviceToken: JSON.stringify(
            this.$store.state.deviceInfo.subscription
          ),
          DeviceType: "Chrome"
        };
        return this.$services.deviceInfo
          .subscribe(this, payload)
          .catch(window.console.error);
      };

      this.isLoading = true;
      this.$services.auth
        .login(this, this.form)
        .then(_ => {
          if (this.$store.state.deviceInfo.subscription) {
            return uploadSubscription();
          } else if (this.$store.state.deviceInfo.token) {
            return uploadAPNSToken();
          }
          return _;
        })
        .then(_ => {
          this.$services.prepareDatas(this).then(this.goMain).then(()=>{this.isLoading = false});
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    goMain() {
      this.$router.push({ name: "announcement-list" });
    },
    onKeyPress(evt) {
      if (evt.key === "Enter") {
        if (this.isFormValid) {
          this.submit();
        }
      }
    }
  },
  created() {
    window.addEventListener("keypress", this.onKeyPress);
  },
  beforeDestroy() {
    window.removeEventListener("keypress", this.onKeyPress);
  }
};
</script>